import { toast as rht } from "react-hot-toast";
import { RxCross2 } from "react-icons/rx";

const options = {
  duration: 3000,
  position: "top-center",
};

const success = (msg) => rht.success(msg, options);

const error = (msg) => rht.error(msg, options);

const profileIncomplete = (navigate) => {
  return rht.custom(
    (t) => (
      <div
        style={{
          transform: "translateY(55px)",
          display: "flex",
        }}
      >
        <div
          style={{
            padding: "10px 12px",
            borderRadius: "8px",
            background: "#fff",
            color: "#222",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
            width: "200px",
            fontFamily: "inherit",
            borderLeft: "3px solid #6570fc",
            position: "relative",
          }}
        >
          <div
            onClick={() => rht.dismiss(t.id)}
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              cursor: "pointer",
              display: "flex",
            }}
          >
            <RxCross2 color="#666" size={14} />
          </div>
          <span style={{ fontWeight: 600, fontSize: "14px", paddingRight: "16px" }}>
            Profile incomplete!
          </span>

          <span
            onClick={() => {
              navigate("/profile-creation", { replace: true });
              rht.dismiss(t.id);
            }}
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#6570fc",
              cursor: "pointer",
              textDecoration: "none",
              marginTop: "2px",
              width: "fit-content",
            }}
          >
            Click here to finish setup →
          </span>
        </div>
      </div>
    ),
    { duration: 15000, position: "top-right" }
  );
};



const promise = (myPromise, msgObj) => rht.promise(myPromise, msgObj, options);

const toast = {
  success,
  error,
  promise,
  profileIncomplete,
};

export default toast;
